import { render, staticRenderFns } from "./CardBadges.vue?vue&type=template&id=e258e654&scoped=true"
import script from "./CardBadges.vue?vue&type=script&lang=js"
export * from "./CardBadges.vue?vue&type=script&lang=js"
import style0 from "./CardBadges.vue?vue&type=style&index=0&id=e258e654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e258e654",
  null
  
)

export default component.exports